<div>
    <aumico-table
        [options]="options"
        [data]="tableData"
        [delegate]="this"
        [filterSubject]="filterSubject"
        detachPager="true"
    >
    </aumico-table>
</div>
